class PricingItem extends HTMLElement {
    constructor() {
        super();

        this.cartAction = document.getElementById('PageContainer').dataset.cartAction;

        this.elements = {
            productForm: this.querySelector('[id^="PricingItem-ProductForm"]'),
            variantInputs: this.querySelectorAll('[id^="PricingItem-VariantInput"]'),
            variantLabels: this.querySelectorAll('[id^="PricingItem-VariantLabel"]'),
            selectedVariantLabel: this.querySelector('[id^="PricingItem-SelectedVariantLabel"]'),
        }

        this.elements.productForm.addEventListener('submit', this.onSubmit.bind(this));

        if (this.elements.variantInputs.length > 0) {
            this.elements.variantInputs.forEach((variantInput) => {
                variantInput.addEventListener('change', this.onVariantChange.bind(this));
            });
        }
    }

    onVariantChange(event) {
        const variantInput = event.target;
        const variantLabel = this.elements.variantLabels[variantInput.dataset.variantIndex];

        this.elements.selectedVariantLabel.innerHTML = variantLabel.innerHTML;

        anime({
            targets: this.elements.selectedVariantLabel,
            opacity: [0, 1],
            duration: 300,
            easing: 'easeOutQuad'
        });
    }

    async onSubmit(event) {
        event.preventDefault();

        if (window.wetheme) {
            const form = event.target;
            const formData = new FormData(form);

            console.log(formData);

            const productItem = {
                "id": formData.get('id'),
                "quantity": 1,
                "selling_plan": formData.get('selling_plan'),
                "paywhirl-plan-selector-group": formData.get('paywhirl-plan-selector-group'),
                "product-id": formData.get('product-id'),
                properties: {
                    "_productImage": formData.get('properties[_productImage]'),
                    "_compareAtPrice": formData.get('properties[_compareAtPrice]'),
                    "_hasOuraRing": formData.get('properties[_hasOuraRing]'),
                    "_hasOuraSizingKit": formData.get('properties[_hasOuraSizingKit]'),
                    "Note": formData.get('properties[Note]'),
                }
            }

            console.log("productItem", productItem);

            await this.addToCart(productItem);
            const cart = await this.getCart();

            if (this.cartAction === 'drawer') {
                window.wetheme.toggleRightDrawer('cart', true, {
                    cart: cart
                });
            } else if (this.cartAction === 'page') {
                window.location.href = '/cart';
            }
        }
    }

    async addToCart(formData) {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({items: [
                formData
            ]})
        });

        const data = await response.json();

        return data;
    }

    async getCart() {
        const response = await fetch('/cart.js', {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const data = await response.json();

        return data;
    }
}

if (!customElements.get('pricing-item')) {
    customElements.define('pricing-item', PricingItem);
}